import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import Link from 'components/Link'

const CommentInputIfSignedOut = ({ location }) => (
  <p
    style={{
      borderTop: '1px solid #f2f2f2',
      margin: 0,
      padding: '1.75rem',
      fontSize: '14px',
      lineHeight: '1.2',
    }}
    data-testid="comment-input-placeholder">
    <Link
      to={{
        pathname: '/signup',
        state: { from: location },
      }}>
      Sign up
    </Link>{' '}
    or
    <Link
      to={{
        pathname: '/signin',
        state: { from: location },
      }}>
      {' '}
      Sign In
    </Link>{' '}
    to comment
  </p>
)

CommentInputIfSignedOut.propTypes = {
  location: PropTypes.object.isRequired,
}

export default withRouter(CommentInputIfSignedOut)
